import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateQuantity from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateQuantity";
import updateUnitOfMeasure from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateUnitOfMeasure";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import Clickable from "@insite/mobius/Clickable";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Move from "@insite/mobius/Icons/Move";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import Radio, { RadioComponentProps } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupComponentProps } from "@insite/mobius/RadioGroup";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import FieldSetPresentationProps, { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getSubscribedProductData from "@TKCCP/Handler/TkccpGetMySuscribedProducts";
import resetSubscribedProduct from "@TKCCP/Handler/TkccpResetSubscribedDataHandler";
import setSubscriptionProductIsSelected from "@TKCCP/Handler/TkccpSelectedSubscriptionProductHandler";
import loadSubscriptionProductData from "@TKCCP/Handler/TkccpSubscriptionProductHandler";
import updateCreateSubscriptionForm from "@TKCCP/Handler/TkccpUpdateSubscriptionHandler";
import CustomApplicationState from "@TKCCP/Store/CustomHandlerCreator/CustomApplicationState";
import { SubscriptionProductList } from "@TKCCP/Widgets/CreateSubscriptions";
import MySubscriptionProductListLine from "@TKCCP/Widgets/MySubscription/MySubscriptionProductListLine";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { SortableContainer, SortableElement, SortableHandle, SortEvent } from "react-sortable-hoc";
import { css } from "styled-components";

interface OwnProps {
    productInfo: ProductInfo;
}

const mapStateToProps = (state: CustomApplicationState) => {
    const selectedSubSubscriptionList = state.tKCCPData.SubscriptionProductStore.setSubscriptionProductIsSelected;
    const editSubscripbedProductList = state.tKCCPData.SubscriptionProductStore.editPageSubscriptionProductList;
    const allProducts = state.tKCCPData.SubscriptionProductStore?.products;
    const filterSubscripbedProducts = allProducts.filter((item: any) => {
        return item.isActiveSubscriptionProduct;
    });

    return {
        SubscribedProducts: state.tKCCPData.SubscriptionProductStore?.productInfoBySubscription,
        allProducts,
        selectedSubSubscriptionList,
        // selectedSubSubscriptionList.length > 0 ? selectedSubSubscriptionList : filterSubscripbedProducts,
        CustomerId: state.context.session.billToId || "",
        UserProfileId: state.context.session.userProfileId || "",
        setSubscribedProductsList: state.tKCCPData.SubscriptionProductStore?.setSubscribedProduct,
        editSubscripbedProductList,
    };
};
export interface MySubscriptionProductListSytles {
    messageText?: TypographyPresentationProps;
    container?: GridContainerProps;
    lineGridItem?: GridItemProps;
    checkboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    checkbox?: CheckboxPresentationProps;
    subscriptionMainContainer?: GridContainerProps;
    subscriptionGirdItem?: GridItemProps;
    subscriptionSubGridItem?: GridItemProps;
    selectedCheckbox?: CheckboxPresentationProps;
    image?: LazyImageProps;
    StartEndWrapper?: InjectableCss;
    priceLabelText?: TypographyPresentationProps;
    productLabelText?: TypographyPresentationProps;
    dateText?: TypographyPresentationProps;
    amountLabelText?: TypographyPresentationProps;
    nameWrapper?: InjectableCss;
    mainWrapper?: InjectableCss;
    quantityWrapper?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    qunaityField?: TextFieldProps;
    dateWrapper?: InjectableCss;
    startDatePicker?: DatePickerPresentationProps;
    endDatePicker?: DatePickerPresentationProps;
    dateSubmitWrapper: GridItemProps;
    radioWrapper?: InjectableCss;
    submitButton?: ButtonPresentationProps;
    radioGroup?: FieldSetGroupPresentationProps<RadioGroupComponentProps>;
    radioButton?: FieldSetPresentationProps<RadioComponentProps>;
    NoendDateWrapper?: InjectableCss;
    mainWrapperEdit?: InjectableCss;
}

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
export const productListStyles: MySubscriptionProductListSytles = {
    checkboxGroup: {
        css: css`
            align-items: flex-start;
            height: 100%;
            justify-content: center;
        `,
    },
    subscriptionGirdItem: {
        css: css`
            flex-direction: column;
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
        `,
    },
    subscriptionSubGridItem: {
        css: css`
            border-top: 1px solid #cecece;
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
            padding: 10px 0px;
            margin: 10px 0px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 0px;
                    `,
                    css`
                        padding-bottom: 0px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    StartEndWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            gap: 15px;
        `,
    },
    nameWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            /* margin-left: 30px; */
            /* width: 400px; */
        `,
    },
    mainWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            position: relative;
            /* border-top: 1px solid grey; */
            padding: 15px;
            /* margin-left: 30px; */
        `,
    },
    productLabelText: {
        css: css`
            font-weight: bold;
            color: #000;
            font-size: x-large;
        `,
    },

    dateText: {
        css: css`
            margin-left: 30px;
            display: flex;
            flex-direction: row;
            gap: 5px;
        `,
    },
    priceLabelText: {
        css: css`
            font-weight: bold;
            color: #7b7b7b;
        `,
    },
    amountLabelText: {
        css: css`
            color: #7b7b7b;
        `,
    },

    quantityWrapper: {
        css: css`
            margin-left: 80px;
        `,
    },
    dateWrapper: {
        css: css`
            display: flex;
            width: 100%;
            max-width: 100%;
            flex-basis: auto;

            & > div {
                margin-right: 30px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        display: grid;
                        grid-template-columns: 45% 45%;
                        & > div > div {
                            width: 100%;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    startDatePicker: {
        calendarIconProps: {
            css: css`
                width: 28px !important;
                padding: 8px 4px !important;
            `,
        },
        clearIconProps: {
            css: css`
                width: 28px !important;
                padding: 8px 4px !important;
            `,
        },
    },
    endDatePicker: {
        calendarIconProps: {
            css: css`
                width: 28px !important;
                padding: 8px 4px !important;
            `,
        },
        clearIconProps: {
            css: css`
                width: 28px !important;
                padding: 8px 4px !important;
            `,
        },
    },
    qunaityField: {
        css: css`
            width: 40px !important;
        `,
    },
    NoendDateWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 5px;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    submitButton: {
        css: css`
            margin-top: 0px;
            margin-bottom: 25px;
        `,
    },
    messageText: {
        variant: "h4",
        css: css`
            display: block;
            margin: auto;
        `,
    },
    container: {
        gap: 0,
        css: css`
            /* Note: below line is to prevent a weird behavior where chrome wants to print anything that will fit
            * comprehensively on a single page on that page, which means the product list appears on page 2
            when rendering a common 8-item list with no notes. That's not ideal, so we're arbitrarily making
            the component large enough that it won't fit on a single page. */
            @media print {
                padding-bottom: 120px;
            }
            border-top: 1px lightgray solid;
        `,
    },
    lineGridItem: {
        width: 12,
        css: css`
            border-bottom: 1px lightgray solid;
            padding: 20px 0;
        `,
    },
    dateSubmitWrapper: {
        css: css`
            display: flex;
            flex-basis: auto;
            max-width: 100%;
            width: 100%;
            align-items: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        align-items: center;
                    `,
                    css`
                        flex-direction: column;
                        align-items: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    radioWrapper: {
        css: css`
            display: flex;
            flex-basis: auto;
            max-width: 100%;
            width: 100%;
            align-items: flex-end;
            border: 1px solid lightgrey;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                    `,
                    css`
                        flex-wrap: wrap;
                    `,
                    null,
                    css`
                        flex-wrap: wrap;
                        width: max-content;
                        margin-right: 17px;
                    `,
                    null,
                ])}
        `,
    },
    radioGroup: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: start;
            align-items: start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 20px;
                        margin-bottom: 20px;
                    `,
                    css`
                        margin-top: 20px;
                        margin-bottom: 20px;
                    `,
                    css`
                        flex-wrap: wrap;
                        width: 100%;
                        grid-column: 1 / 3;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    radioButton: {
        css: css`
            margin: 10px 20px 5px 0;
        `,
    },
    mainWrapperEdit:{
        css: css`
            position: relative;
        `,
    }
};

const styles = productListStyles;

const mapDispatchToProps = {
    updateQuantity,
    getSubscribedProductData,
    updateUnitOfMeasure,
    loadSubscriptionProductData,
    setSubscriptionProductIsSelected,
    updateCreateSubscriptionForm,
    resetSubscribedProduct,
};

const MySubscriptionProductList = ({
    productInfo,
    CustomerId,
    UserProfileId,
    getSubscribedProductData,
    allProducts,
    SubscribedProducts,
    selectedSubSubscriptionList,
    setSubscribedProductsList,
    setSubscriptionProductIsSelected,
    loadSubscriptionProductData,
    updateCreateSubscriptionForm,
    editSubscripbedProductList,
    resetSubscribedProduct,
}: Props) => {
    const [selectedProduct, setSelectedProduct] = useState(false);
    const [isloading, setIsLoading] = useState(true);
    useEffect(() => {
        if (Object.keys(SubscribedProducts).length) {
            setIsLoading(false);
        }
    }, [SubscribedProducts]);

    useEffect(() => {
        const SubscriptionId = getIdFromurl();
        loadSubscriptionProductData({
            SubscriptionId,
            customerBillToId: CustomerId,
        });
        getSubscribedProductData({
            CustomerId,
            UserProfileId,
        });

        return () => {
            resetSubscribedProduct({});
        };
    }, []);

    const [repeatPeriod, setRepeatPeriod] = React.useState("");
    const [startDate, setStartDate] = React.useState<Date | undefined>(undefined);
    const [endDate, setEndDate] = React.useState<Date | undefined>(undefined);
    const [hasEndDate, setHasEndDate] = React.useState(false);
    const toasterContext = useContext(ToasterContext);
    const history = useHistory();

    useEffect(() => {
        if (currentSubscribedProduct[0]) {
            setStartDate(new Date(currentSubscribedProduct[0].startDate));
            setRepeatPeriod(currentSubscribedProduct[0].nextOrderFrequencyDays);
            currentSubscribedProduct[0].endDate && setEndDate(new Date(currentSubscribedProduct[0].endDate));
            currentSubscribedProduct[0].endDate ? setHasEndDate(true) : setHasEndDate(false);
        }
    }, [setSubscribedProductsList]);

    const currentSubscribedProduct = setSubscribedProductsList.filter((product: any) => {
        const SubscriptionId = getIdFromurl();
        return SubscriptionId === product.id;
    });

    function getIdFromurl() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        return urlParams.get("id") ?? "";
    }
    const selectChangeHandler = () => {};

    const repeatPeriodChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRepeatPeriod(event.currentTarget.value);
    };

    const startDateChangeHandler = ({ selectedDay }: DatePickerState) => {
        setStartDate(selectedDay || new Date());
        if (selectedDay && endDate && selectedDay > endDate) {
            setEndDate(undefined);
            setHasEndDate(false);
        }
    };
    //

    const hasEndDateChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        if (hasEndDate) {
            setEndDate(undefined);
            setHasEndDate(false);
        }
    };
    //

    const endDateChangeHandler = ({ selectedDay }: DatePickerState) => {
        setEndDate(selectedDay);
        setHasEndDate(!!selectedDay);
    };
    // eslint-disable-next-line array-callback-return
    const filterIsActiveSubscribedProdcuts = allProducts
        // eslint-disable-next-line array-callback-return
        .filter((product: any) => {
            return product.isActiveSubscriptionProduct;
        });

    const subscriptionSubmitHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        event.preventDefault();
        const subscriptionId = getIdFromurl();
        const idsList = editSubscripbedProductList.map((product: any) => {
            return product.ProductId;
        });

        const filtered = editSubscripbedProductList.filter(
            (product: any, index: number) => !idsList.includes(product.ProductId, index + 1),
        );

        const QTYY = filtered.every(abc => {
            return Number(abc.QtyOrdered) > 0;
        });
        if (!QTYY) {
            toasterContext.addToast({
                body: translate("Quantity of selected product should be greater tha 0"),
                messageType: "danger",
            });
            window.scrollTo(0, 0);
            return;
        }

        
        const isAllTrue = filtered.every((item)=>{
            return item.IsActive === false;
        })
        
        if (filtered?.length === 0 || isAllTrue) {
            toasterContext.addToast({
                body: translate("Please select atleast 1 product "),
                messageType: "danger",
            });
            window.scrollTo(0, 0);
            return;
        }

        const updateSubscriptionData = {
            Id: subscriptionId,
            Name: currentSubscribedProduct[0].name,
            CustomerId,
            UserProfileId,
            StartDate: startDate?.toISOString() ?? "",
            EndDate: endDate?.toISOString() ?? null,
            IsActive: true,
            NextOrderFrequencyInDays: repeatPeriod,
            SubscriptionProductsList: filtered,
            onSuccess: () => {
                toasterContext.addToast({ body: translate("Subscription Updated "), messageType: "success" });
                history.push("MyAccount/MySubscription");
            },
        };

        updateCreateSubscriptionForm(updateSubscriptionData);
    };

    return (
        <>
        <GridItem {...styles.dateSubmitWrapper}>
                <StyledWrapper {...styles.dateWrapper}>
                    <DatePicker
                        {...styles.startDatePicker}
                        label={translate("Start Date")}
                        selectedDay={startDate}
                        onDayChange={startDateChangeHandler}
                    />
                    <StyledWrapper {...styles.NoendDateWrapper}>
                        <DatePicker
                            {...styles.endDatePicker}
                            label={translate("End Date")}
                            selectedDay={endDate}
                            dateTimePickerProps={{ minDate: startDate }}
                            onDayChange={endDateChangeHandler}
                        />
                        <Checkbox checked={!hasEndDate} onChange={hasEndDateChangeHandler}>
                            {translate("No end date")}
                        </Checkbox>
                    </StyledWrapper>
                    <RadioGroup
                        as="legend"
                        label={translate("Frequency")}
                        {...styles.radioGroup}
                        value={repeatPeriod}
                        defaultValue="14"
                        onChangeHandler={repeatPeriodChangeHandler}
                    >
                        <StyledWrapper {...styles.radioWrapper}>
                            <Radio {...styles.radioButton} key="7" value="7">
                                {translate("Weekly")}
                            </Radio>
                            <Radio {...styles.radioButton} key="14" value="14">
                                {translate("Biweekly")}
                            </Radio>
                            <Radio {...styles.radioButton} key="30" value="30">
                                {translate("Monthly")}
                            </Radio>
                            <Radio {...styles.radioButton} key="90" value="90">
                                {translate("Quarterly")}
                            </Radio>
                        </StyledWrapper>
                    </RadioGroup>
                </StyledWrapper>

                <Button {...styles.submitButton} onClick={subscriptionSubmitHandler}>
                    {translate("submit")}
                </Button>
            </GridItem>
            <StyledWrapper {...styles.mainWrapperEdit}>
                {!isloading ? (
                    [...allProducts]
                        .sort((a: any, b: any) => {
                            // Sorting products to display isActiveSubscriptionProduct=true first
                            if (a.isActiveSubscriptionProduct && !b.isActiveSubscriptionProduct) {
                                return -1;
                            }
                            if (!a.isActiveSubscriptionProduct && b.isActiveSubscriptionProduct) {
                                return 1;
                            }
                            return 0;
                        })
                        .map((product: any, index: any) => {
                            const productId = product["productId"];
                            const isActiveSubscription = product.isActiveSubscriptionProduct;

                            return (
                                <StyledWrapper key={index} {...styles.mainWrapper}>
                                    {/* Rendering based on isActiveSubscriptionProduct */}
                                    {isActiveSubscription ? (
                                        // Render components for active subscription products
                                        <>
                                            <SubscriptionProductList
                                                product={product}
                                                productInfo={SubscribedProducts?.[productId]}
                                                key={index}
                                                updateUnitOfMeasure={updateUnitOfMeasure}
                                                updateQuantity={updateQuantity}
                                                setSubscriptionProductIsSelected={setSubscriptionProductIsSelected}
                                                selectedSubSubscriptionList={selectedSubSubscriptionList}
                                                allListOfProducts={allProducts}
                                                editProductPageFlag={true}
                                            />
                                            {/* Additional components for active subscription */}
                                        </>
                                    ) : (
                                        // Render components for inactive subscription products
                                        <>
                                            <SubscriptionProductList
                                                product={product}
                                                productInfo={SubscribedProducts?.[productId]}
                                                key={index}
                                                updateUnitOfMeasure={updateUnitOfMeasure}
                                                updateQuantity={updateQuantity}
                                                setSubscriptionProductIsSelected={setSubscriptionProductIsSelected}
                                                selectedSubSubscriptionList={selectedSubSubscriptionList}
                                                allListOfProducts={allProducts}
                                                editProductPageFlag={true}
                                            />
                                            {/* Additional components for inactive subscription */}
                                        </>
                                    )}
                                </StyledWrapper>
                            );
                        })
                ) : (
                    <StyledWrapper {...styles.centeringWrapper}>
                        <LoadingSpinner {...styles.spinner} data-test-selector="productListCardListSpinner" />
                    </StyledWrapper>
                )}
                {/* Additional code if needed */}
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MySubscriptionProductList),
    definition: {
        group: "Basic",
        displayName: "Edit Subscription",
    },
};

export default widgetModule;
